export default __webpack_public_path__ + "static/media/fail.1c2963ee.png";